import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateSettingsPage,
  getSettingsListAll,
} from "../../../redux/settings/action";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { invoiceVatValidation } from "../../Constant/constant";
import professional from "../../assets/images/professional.png";
import { getOssClient } from "../../Common/Utils/ossUtils";

const InvoiceData = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      vat_percent: settingsListData?.vat_percent || "",
      company_registration_number:
        settingsListData?.company_registration_number || "",
      company_vat_number: settingsListData?.company_vat_number || "",
      company_name: settingsListData?.company_name || "",
      logo: settingsListData?.logo || "",
      free_invoice_count:settingsListData?.free_invoice_count|| ""
    },
    validationSchema: invoiceVatValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: settingsListData?.id,
    };
    dispatch(UpdateSettingsPage(data, setLoading));
  };

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, [dispatch]);

  const handleLogoChange = async (event) => {
    const file = event.currentTarget.files[0];

    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
      ];

      if (!validImageTypes.includes(file.type)) {
        alert("Only image files (JPG, PNG, GIF, WebP) are allowed.");
        event.target.value = ""; // Reset the input
        return;
      }

      setImageLoading(true);
      const ossClient = await getOssClient();

      const fileName = `images/${Date.now()}_${file.name}`;
      const result = await ossClient.put(fileName, file, {
        progress: (p) => {
          setUploadProgress(Math.round(p * 100));
        },
      });
      formik.setFieldValue("logo", result.url);
      setImageLoading(false);
    }
  };

  return (
    <div className="">
      <h3 className="pb-3">Invoice Data Info</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Invoice Vat(%)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter duration"
              name="vat_percent"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.vat_percent}
            />
            {formik.touched.vat_percent && formik.errors.vat_percent ? (
              <div className="error">{formik.errors.vat_percent}</div>
            ) : null}
          </div>
          <div className="col-md-4 form-group">
            <label>Company Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter company name"
              name="company_name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.company_name}
            />
            {formik.touched.company_name && formik.errors.company_name ? (
              <div className="error">{formik.errors.company_name}</div>
            ) : null}
          </div>
          <div className="col-md-4 form-group">
            <label>Company Registration Number</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter registration number"
              name="company_registration_number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.company_registration_number}
            />
            {formik.touched.company_registration_number &&
            formik.errors.company_registration_number ? (
              <div className="error">
                {formik.errors.company_registration_number}
              </div>
            ) : null}
          </div>
          <div className="col-md-4 form-group">
            <label>Company VAT Number</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter VAT number"
              name="company_vat_number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.company_vat_number}
            />
            {formik.touched.company_vat_number &&
            formik.errors.company_vat_number ? (
              <div className="error">{formik.errors.company_vat_number}</div>
            ) : null}
          </div>
           <div className="col-md-4 form-group">
            <label>Free Invocie Count(API Key)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter free invoice"
              name="free_invoice_count"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.free_invoice_count}
            />
            {formik.touched.free_invoice_count &&
            formik.errors.free_invoice_count ? (
              <div className="error">{formik.errors.free_invoice_count}</div>
            ) : null}
          </div>
          <div className="business-logo d-flex align-items-center col-md-12 form-group justify-content-center flex-column">
            <div className="profile-edit">
              {imageLoading ? (
                <div className="loader-container">
                  <i className="fa fa-spinner fa-spin loader-icon"></i>{" "}
                </div>
              ) : (
                <img
                  src={formik.values.logo || professional}
                  alt="Business Logo"
                />
              )}
              <label htmlFor="logo-upload" style={{ cursor: "pointer" }}>
                <i className="fa fa-pencil"></i>
              </label>
            </div>
            <div className="text-center">
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                id="logo-upload"
                onChange={handleLogoChange}
              />
              <span>Accept Image only</span>
              <p>Fatoora Logo</p>
            </div>
            {formik.touched.logo && formik.errors.logo ? (
              <div className="error">{formik.errors.logo}</div>
            ) : null}
          </div>
        </div>
        <button
          className="submit-btn d-block mx-auto mt-3  "
          style={{ width: "max-content" }}
          type="submit"
        >
          {!loading ? "Submit" : <Spinner />}
        </button>
      </form>
    </div>
  );
};

export default InvoiceData;
